import { FC, useState } from "react";
import { Route, Routes } from "react-router-dom";
import Identification from "./components/pages/identification/Identification";
import EditPage from "./components/pages/edit-page/EditPage";
import LoadingPage from "./components/pages/loading/LoadingPage";
import ForbiddenPage from "./components/pages/forbidden/ForbiddenPage";
import ProtectedRoutes from "./utils/ProtectedRoutes";
import AdminRoutes from "./utils/AdminRoutes";
import InnCheck from "./components/pages/inn-check/InnCheck";
import DataView from "./components/pages/data-view/DataView";
import Login from "./components/pages/login/Login";
import AddOperator from "./components/pages/operator/Operator";
import AdminPanel from "./components/pages/admin-panel/AdminPanel";
import AdminLayout from "./components/AdminLayout";
import Operator from "./components/pages/operator/Operator";
import Organization from "./components/pages/organization/Organization";
import { ToastContainer } from "react-toastify";

interface IAppProps {}

const App: FC<IAppProps> = () => {
  const [frontPassportPhotoBase64, setFrontPassportPhotoBase64] = useState<
    string | null
  >(null);

  const [backPassportPhotoBase64, setBackPassportPhotoBase64] = useState<
    string | null
  >(null);

  return (
    <>
      <Routes>
        <Route index element={<Login />} />
        <Route path="/main" element={<LoadingPage />} />
        <Route path="/403" element={<ForbiddenPage />} />
        <Route element={<ProtectedRoutes />}>
          <Route element={<AdminRoutes />}>
            <Route element={<AdminLayout />}>
              <Route path="/admin-panel" element={<AdminPanel />} />
              <Route path="/operator" element={<Operator />} />
              <Route path="/organization" element={<Organization />} />
            </Route>
          </Route>
          <Route path="/inn-check" element={<InnCheck />} />
          <Route path="/data-view" element={<DataView />} />
          <Route
            path="/identification"
            element={
              <Identification
                isFaceControl={false}
                setBackPassportPhoto={setBackPassportPhotoBase64}
                setFrontPassportPhoto={setFrontPassportPhotoBase64}
              />
            }
          />
          <Route
            path="/verification"
            element={
              <Identification
                isFaceControl={true}
                setBackPassportPhoto={setBackPassportPhotoBase64}
                setFrontPassportPhoto={setFrontPassportPhotoBase64}
              />
            }
          />
          <Route
            path="/support"
            element={
              <EditPage
                backPassportPhoto={backPassportPhotoBase64}
                frontPassportPhoto={frontPassportPhotoBase64}
              />
            }
          />
        </Route>
      </Routes>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        draggable
        theme="colored"
      />
    </>
  );
};

export default App;
